<div class="flex flex-wrap mt-3 mb-3">
  <div class="w-1/2 px-3">
    <div class="fq-card fuseqCard m-0">
      <div (click)="toggleDownload()" [attr.aria-expanded]="!isDownloadCollapsed" aria-controls="downloadTrendCollapse" class="fq-card-header fuseqCardHeader cursor-pointer">
        Download trend
      </div>
      <div class="fq-card-body fuseqCardBody" id="downloadTrendCollapse" [style.display]="isDownloadCollapsed ? 'none' : 'block'">
        <div echarts [options]="downloadTrendOptions()" (chartInit)="onDownloadChartInit($event)" class="h-[300px]"></div>
      </div>
    </div>
  </div>
  <div class="w-1/2 px-3">
    <div class="fq-card fuseqCard m-0">
      <div (click)="toggleUpload()" [attr.aria-expanded]="!isUploadCollapsed" aria-controls="uploadTrendCollapse" class="fq-card-header fuseqCardHeader cursor-pointer">
        Upload trend
      </div>
      <div class="fq-card-body fuseqCardBody" id="uploadTrendCollapse" [style.display]="isUploadCollapsed ? 'none' : 'block'">
        <div echarts [options]="uploadTrendOptions()" (chartInit)="onUploadChartInit($event)" class="h-[300px]"></div>
      </div>
    </div>
  </div>
</div>

<fq-table [tableId]="'speedtestHistory'" [scrollable]="true" [scrollHeight]="'400px'" [selectableRows]="true" [selectionMode]="'multiple'"
  [value]="value()" [useTecnologiaAgglomerataExport]="true" [showSearch]="true" [showOption]="true"
  [exportFileName]="'speedtest'" [columns]="[
  {field: '', header: 'Action'},
  {field: 'frazionario', header: 'Frazionario'},
  {field: 'tecnologia', header: 'Tecnologia'},
  {field: 'Cella', header: 'Cella'},
  {field: 'status', header: 'Status'},
  {field: 'start_date', header: 'Start Date'},
  {field: 'cellular', header: 'Cellular'},
  {field: 'cellular_download_mbps', header: 'Cellular_download_mbps', show:false},
  {field: 'cellular_upload_mbps', header: 'Cellular_upload_mbps', show:false},
  {field: 'cellular_jitter', header: 'cellular jitter', show:false},
  {field: 'cellular_latency', header: 'cellular latency', show:false},
  {field: 'cellular_loss', header: 'cellular loss', show:false},
  {field: 'nrd1', header: 'nrd1'},
  {field: 'nrd1_download_mbps', header: 'nrd1_download_mbps', show:false},
  {field: 'nrd1_upload_mbps', header: 'nrd1_upload_mbps', show:false},
  {field: 'nrd1_jitter', header: 'nrd1_jitter', show:false},
  {field: 'nrd1_latency', header: 'nrd1_latency', show:false},
  {field: 'nrd1_loss', header: 'nrd1_loss', show:false},
  {field: 'nrd2', header: 'nrd2'},
  {field: 'nrd2_download_mbps', header: 'nrd2_download_mbps', show:false},
  {field: 'nrd2_upload_mbps', header: 'nrd2_upload_mbps', show:false},
  {field: 'nrd2_jitter', header: 'nrd2_jitter', show:false},
  {field: 'nrd2_latency', header: 'nrd2_latency', show:false},
  {field: 'nrd2_loss', header: 'nrd2_loss', show:false},
  {field: 'mpls1', header: 'mpls1'},
  {field: 'mpls1_download_mbps', header: 'mpls1_download_mbps', show:false},
  {field: 'mpls1_upload_mbps', header: 'mpls1_upload_mbps', show:false},
  {field: 'mpls1_jitter', header: 'mpls1_jitter', show:false},
  {field: 'mpls1_latency', header: 'mpls1_latency', show:false},
  {field: 'mpls1_loss', header: 'mpls1_loss', show:false},
  {field: 'mpls2', header: 'mpls2'},
  {field: 'mpls2_download_mbps', header: 'mpls2_download_mbps', show:false},
  {field: 'mpls2_upload_mbps', header: 'mpls2_upload_mbps', show:false},
  {field: 'mpls2_jitter', header: 'mpls2_jitter', show:false},
  {field: 'mpls2_latency', header: 'mpls2_latency', show:false},
  {field: 'mpls2_loss', header: 'mpls2_loss', show:false},
  {field: 'rsrp', header: 'rsrp'},
  {field: 'rsrq', header: 'rsrq'},
  {field: 'rssi', header: 'rssi'},
  {field: 'iccid', header: 'ICCID'}
  ]" >
    <ng-template #body let-row let-columnsOptions="columnsOptions">
      <tr>
        <td class="text-center whitespace-nowrap">
        <button
          pTooltip="Details" tooltipPosition="top" appendTo="body" (click)="onDetails(row)" class="fq-btn fq-btn-icon fq-btn-outline-primary">
          <fa-icon [icon]="['fas', 'eye']"></fa-icon>
        </button>
        </td>
  <ng-container *ngFor="let col of columnsOptions">
    <ng-container [ngSwitch]="col.field || col.header">
      <td *ngSwitchCase="'frazionario'" class="whitespace-nowrap text-center align-middle">{{row.frazionario}}</td>
      <td *ngSwitchCase="'tecnologia'" class="whitespace-nowrap text-center align-middle">{{row.tecnologia}}</td>
      <td *ngSwitchCase="'Cella'" class="whitespace-nowrap text-center align-middle">{{row.Cella}}</td>
      <td *ngSwitchCase="'start_date'" class="whitespace-nowrap text-center align-middle">{{row.start_date | date: 'yyyy-MM-dd HH:mm:ss'}}</td>
      <td *ngSwitchCase="'status'" class="whitespace-nowrap text-center align-middle">{{row.status}}</td>
      <td *ngSwitchCase="'cellular'" [innerHTML]="row.cellular" class="whitespace-nowrap text-center align-middle"></td>
      <td *ngSwitchCase="'cellular_download_mbps'" class="whitespace-nowrap text-center align-middle">{{row.cellular_download_mbps}}</td>
      <td *ngSwitchCase="'cellular_upload_mbps'" class="whitespace-nowrap text-center align-middle">{{row.cellular_upload_mbps}}</td>
      <td *ngSwitchCase="'cellular_jitter'" class="whitespace-nowrap text-center align-middle">{{row.cellular_jitter}}</td>
      <td *ngSwitchCase="'cellular_latency'" class="whitespace-nowrap text-center align-middle">{{row.cellular_latency}}</td>
      <td *ngSwitchCase="'cellular_loss'" class="whitespace-nowrap text-center align-middle">{{row.cellular_loss}}</td>
      <td *ngSwitchCase="'nrd1'" [innerHTML]="row.nrd1" class="whitespace-nowrap text-center align-middle"></td>
      <td *ngSwitchCase="'nrd1_download_mbps'" class="whitespace-nowrap text-center align-middle">{{row.nrd1_download_mbps}}</td>
      <td *ngSwitchCase="'nrd1_upload_mbps'" class="whitespace-nowrap text-center align-middle">{{row.nrd1_upload_mbps}}</td>
      <td *ngSwitchCase="'nrd1_jitter'" class="whitespace-nowrap text-center align-middle">{{row.nrd1_jitter}}</td>
      <td *ngSwitchCase="'nrd1_latency'" class="whitespace-nowrap text-center align-middle">{{row.nrd1_latency}}</td>
      <td *ngSwitchCase="'nrd1_loss'" class="whitespace-nowrap text-center align-middle">{{row.nrd1_loss}}</td>
      <td *ngSwitchCase="'nrd2'" [innerHTML]="row.nrd2" class="whitespace-nowrap text-center align-middle"></td>
      <td *ngSwitchCase="'nrd2_download_mbps'" class="whitespace-nowrap text-center align-middle">{{row.nrd2_download_mbps}}</td>
      <td *ngSwitchCase="'nrd2_upload_mbps'" class="whitespace-nowrap text-center align-middle">{{row.nrd2_upload_mbps}}</td>
      <td *ngSwitchCase="'nrd2_jitter'" class="whitespace-nowrap text-center align-middle">{{row.nrd2_jitter}}</td>
      <td *ngSwitchCase="'nrd2_latency'" class="whitespace-nowrap text-center align-middle">{{row.nrd2_latency}}</td>
      <td *ngSwitchCase="'nrd2_loss'" class="whitespace-nowrap text-center align-middle">{{row.nrd2_loss}}</td>
      <td *ngSwitchCase="'mpls1'" [innerHTML]="row.mpls1" class="whitespace-nowrap text-center align-middle"></td>
      <td *ngSwitchCase="'mpls1_download_mbps'" class="whitespace-nowrap text-center align-middle">{{row.mpls1_download_mbps}}</td>
      <td *ngSwitchCase="'mpls1_upload_mbps'" class="whitespace-nowrap text-center align-middle">{{row.mpls1_upload_mbps}}</td>
      <td *ngSwitchCase="'mpls1_jitter'" class="whitespace-nowrap text-center align-middle">{{row.mpls1_jitter}}</td>
      <td *ngSwitchCase="'mpls1_latency'" class="whitespace-nowrap text-center align-middle">{{row.mpls1_latency}}</td>
      <td *ngSwitchCase="'mpls1_loss'" class="whitespace-nowrap text-center align-middle">{{row.mpls1_loss}}</td>
      <td *ngSwitchCase="'mpls2'" [innerHTML]="row.mpls2" class="whitespace-nowrap text-center align-middle"></td>
      <td *ngSwitchCase="'mpls2_download_mbps'" class="whitespace-nowrap text-center align-middle">{{row.mpls2_download_mbps}}</td>
      <td *ngSwitchCase="'mpls2_upload_mbps'" class="whitespace-nowrap text-center align-middle">{{row.mpls2_upload_mbps}}</td>
      <td *ngSwitchCase="'mpls2_jitter'" class="whitespace-nowrap text-center align-middle">{{row.mpls2_jitter}}</td>
      <td *ngSwitchCase="'mpls2_latency'" class="whitespace-nowrap text-center align-middle">{{row.mpls2_latency}}</td>
      <td *ngSwitchCase="'mpls2_loss'" class="whitespace-nowrap text-center align-middle">{{row.mpls2_loss}}</td>
      <td *ngSwitchCase="'rsrp'" class="whitespace-nowrap text-center align-middle">{{row.rsrp}}</td>
      <td *ngSwitchCase="'rsrq'" class="whitespace-nowrap text-center align-middle">{{row.rsrq}}</td>
      <td *ngSwitchCase="'rssi'" class="whitespace-nowrap text-center align-middle">{{row.rssi}}</td>
      <td *ngSwitchCase="'iccid'" class="whitespace-nowrap text-center align-middle">{{row.iccid}}</td>
    </ng-container>
  </ng-container>
</tr>
</ng-template>
</fq-table>

<p-dialog [position]="'top'" [visible]="historyDetailsVisible" (visibleChange)="historyDetailsVisible = $event; !$event ? closeHistoryDetails() : null" [header]="headerHistoryDetails" [modal]="true" [draggable]="false" [resizable]="true" [style]="{width: '90vw', maxWidth: '1200px', 'margin-top': '3rem'}" [closable]="true">
    <div class="mt-4">
      <fq-dialog-nav [sections]="detailSections" [(active)]="detailTab" variant="pill" enclosed>
        @if (detailTab === 'tunnel') {
          <div [innerHTML]="tunnel" class="fq-html-content text-center"></div>
        }
        @if (detailTab === 'traffic') {
          <fq-table [tableId]="'speedtestHistoryTraffic'" [scrollable]="true" [scrollHeight]="'flex'"
            [value]="traffic" [useTecnologiaAgglomerataExport]="true" [showSearch]="true" [showOption]="true"
            [exportFileName]="'Traffic'" [columns]="[
            {field: 'name', header: 'Interface'},
            {field: 'rx_bytes', header: 'Received'},
            {field: 'tx_bytes', header: 'Sent'}
            ]">
            <ng-template #body let-traffic>
              <tr>
                <td class="text-center">{{ traffic.name }}</td>
                <td tooltip="{{traffic.rx_bytes}}" tooltipPosition="top" class="text-center">{{ convertBytes(traffic.rx_bytes) }}</td>
                <td tooltip="{{traffic.tx_bytes}}" tooltipPosition="top" class="text-center">{{ convertBytes(traffic.tx_bytes) }}</td>
              </tr>
            </ng-template>
          </fq-table>
        }
      </fq-dialog-nav>
    </div>
</p-dialog>
